import React, { useState } from 'react';
import { FiChevronLeft, FiCalendar } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { Page, Button, Input, DatePicker, Checkbox, alert, Select } from 'equasion-lib';
import { Formik, Form } from 'formik';
import { unserializedReceivingValidation } from './UnserializedReceiving.validation';
import './UnserializedReceiving.scss';
import { useRootStore } from '@/lib/providers/RootProvider';
import WarehouseProductDisplay from '@/lib/shared-coms/WarehouseProductDisplay';

function UnserializedReceiving({ purchaseOrder, receiveUnserializedPurchaseOrder }) {
  const companyId = useRootStore((state) => state.selectedCompany.id);
  const navigate = useNavigate();
  const [itemsAreMissing, setItemsAreMissing] = useState(false);
  const {
    id: purchaseOrderId,
    clientPurchaseOrderNumber,
    vendor: { companyName },
    orderItems
  } = purchaseOrder;
  const totalQuantity = orderItems.reduce((acc, item) => acc + item.quantity, 0);

  const submitReceiveUnserializedPurchaseOrder = async (values, actions) => {
    const { setSubmitting } = actions;
    try {
      const { orderItems } = values;
      await receiveUnserializedPurchaseOrder({
        variables: {
          id: purchaseOrderId,
          orderItems: orderItems.map((item) => ({
            productId: item.productId,
            quantity: item.quantity
          })),
          companyId: companyId
        }
      });
      alert('Received', 'Successfully received products', 4, 'success');
      navigate('/unserialized?tab=receiving');
    } catch (e) {
      console.log(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Page className="unserialized-receiving">
      <div className="action-top-bar">
        <Button
          type="secondary"
          iconBefore={<FiChevronLeft />}
          onClick={() => navigate('/unserialized?tab=receiving')}
        >
          Back
        </Button>
        <div className="order-details">
          <h1>Receiving</h1>
        </div>
      </div>
      <div className="content">
        <div className="order-details">
          <div className="order-number">
            <span>PO #{clientPurchaseOrderNumber}</span>
          </div>
          <div className="order-info">
            <span>
              {totalQuantity} {totalQuantity === 1 ? 'Item' : 'Items'}
            </span>
            <span>•</span>
            <span className="company-name">{companyName}</span>
          </div>
          <div></div>
        </div>
        <Checkbox
          form={false}
          label="PO has missing items"
          defaultValue={itemsAreMissing}
          value={itemsAreMissing}
          onChange={({ value }) => setItemsAreMissing(value)}
          className="items-are-missing-checkbox"
        />
        {itemsAreMissing && (
          <div
            style={{
              color: 'var(--n100)',
              fontSize: '1.3rem',
              margin: '-1rem 0 1.6rem 0.5rem'
            }}
          >
            Check the items below that are missing. Enter quantities only for the items
            you actually received.
          </div>
        )}
        <Formik
          initialValues={{
            orderItems: orderItems.map((item) => ({
              productId: item.productId,
              quantity: item.quantity,
              missing: false
            }))
          }}
          validationSchema={unserializedReceivingValidation()}
          validateOnBlur={false}
          onSubmit={submitReceiveUnserializedPurchaseOrder}
        >
          {({ isSubmitting, values, errors }) => {
            console.log(errors);
            return (
              <Form className="unserialized-receiving-form">
                <div className="flex space-between order-items-header">
                  <span>
                    {orderItems.length === 1
                      ? `Item (${orderItems.length})`
                      : `Items (${orderItems.length})`}
                  </span>
                  <span>Qty</span>
                </div>
                {orderItems.map((item, i) => (
                  <div>
                    <div key={item.productId}>
                      <div>
                        {itemsAreMissing && (
                          <Checkbox name={`orderItems.${i}.missing`} label="" />
                        )}

                        <WarehouseProductDisplay product={item.product} />
                      </div>
                      <span className="quantity">{item.quantity}</span>
                    </div>
                    {values.orderItems[i].missing && (
                      <Input
                        name={`orderItems.${i}.quantity`}
                        label="Quantity Received"
                        inputType="number"
                        inputMode="numeric"
                        autoFocus
                        onFocus={(e) => e.target.select()}
                      />
                    )}
                  </div>
                ))}

                <Button type="primary" isSubmit disabled={isSubmitting} fullWidth>
                  {itemsAreMissing && values.orderItems.some((item) => item.missing)
                    ? 'Receive And Split Missing'
                    : 'Receive'}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Page>
  );
}

export default UnserializedReceiving;
